import React, { Component } from 'react'
// import { NavLink } from 'react-router-dom'

import './styles.scss'

export default class Ribbon extends Component {
  render() {
      return (
        <div className = 'ribbon'>
          {/* eslint-disable-next-line */}
          <span>Get fully prepared for your PM interview with <b>Aced</b>. <a href={`https://www.aced.io/courses/pm?utm_source=dpp&utm_medium=affiliate&utm_campaign=dpp-banner&ref=dpp`} target = '_blank' className = 'underline hover color-primary'>Join&nbsp;Today&nbsp;→</a></span>
        </div>
      )
  }
}
